'use strict';
/**
 * @author Maxim Seredkin
 */


import { Operator } from '../../operator/enum/operator';
import { EntityStatus } from '../enum/entityStatus';

export default ['$rootScope', '$scope', 'SupportService', 'SupportFilterService', 'OperatorService', '$utils', 'SupportTypeService', 'AreaService', 'OkvedMultiService', 'IndustryService', 'OperationTypeService', '$security',
                function($rootScope, $scope, SupportService, SupportFilterService, OperatorService, $utils, SupportTypeService, AreaService, OkvedService, IndustryService, OperationTypeService, $security) {
                    // инициализация
                    $scope.paginationSize = 40;
                    $scope.pagination = {
                        search: '',
                        isPaging: true,
                        page: 1,
                        size: $scope.paginationSize,
                        totalPages: null,
                        totalItems: null
                    };
                    $scope.items = [];
                    $scope.loading = false;
                    $scope.refresh = refresh;

                    $scope.oneMorePage = oneMorePage;
                    $scope.applyFilter = applyFilter;
                    $scope.toggleFilter = toggleFilter;
                    $scope.openCreateSupport = openCreateSupport;
                    $scope.openEditSupport = $rootScope.onClickSupport || openEditSupport;
                    $scope.cancel = $rootScope.closeSupportTool || null;
                    $scope.openFilter = $utils.openControlSidebar;
                    $scope.isShowEdit = function () {
                        return $security.isAllowWrite('/support-measures');
                    }

                    init();

                    async function init() {
                        $scope.loading = true;
                        $rootScope.title = '';
                        loadTypes();
                        loadOperators();
                        Promise.all([
                            loadOkveds(),
                            loadAreas(),
                            loadIndustries(),
                            loadOperations()
                        ]).then(() => {
                            refresh();
                        }).catch(() => ({}));
                    }
                    // region Functions

                    function toggleFilter() {
                        $scope.isFilterOpen = !$scope.isFilterOpen;
                    }

                    function applyFilter(items) {
                        SupportFilterService.setFilters(items);
                        refresh();
                    }

                    function openCreateSupport() {
                        SupportService.create($scope.types, $scope.okveds, $scope.areases, $scope.operators, $scope.industries, $scope.operations).result.then(support => {
                            // Создали меру
                            console.log(support);
                            SupportService.api.create(SupportService.convertToDTO(support), () => {
                                $scope.refresh();
                            });
                        }).catch(() => ({}));
                    }

                    function openEditSupport(item) {
                        SupportService.edit(item, $scope.types, $scope.okveds, $scope.areases, $scope.operators, $scope.industries, $scope.operations).result.then(result => {
                            if (result.reason === 'edit') {
                                console.log(result);
                                SupportService.api.update({ supportId: result.support.id }, SupportService.convertToDTO(result.support), () => {
                                    $scope.refresh();
                                });
                                // Отредактировали меру
                            } else if (result.reason === 'delete') {
                                // УДалили меру
                                console.log(result);
                                SupportService.api.delete( { supportId: result.support.id }, () => {
                                    $scope.refresh();
                                });
                            }
                        }).catch(() => ({}));
                    }

                    function loadOkveds() {
                        return new Promise(resolve => {
                            OkvedService.api.get(
                                {
                                    filters: [`'status' EQ '${EntityStatus.ENABLED}'`],
                                    sorts: ['name:ASC'],
                                },
                            )
                            .$promise
                            .then(data => {
                                $scope.okveds = [];
                                $scope.okvedsObject = data._embedded.reduce((acc, red) => {
                                    const id = red.id;
                                    acc[id] = red;
                                    return acc;
                                }, {});
                                resolve();
                            }).catch(() => ({}));
                        });
                    }

                    function loadOperations() {
                        return new Promise(resolve => {
                            OperationTypeService.api.get(
                                {
                                    filters: [`'status' EQ '${EntityStatus.ENABLED}'`],
                                    sorts: ['name:ASC'],
                                },
                            )
                            .$promise
                            .then(data => {
                                $scope.operations = data._embedded;
                                $scope.operationsObject = data._embedded.reduce((acc, red) => {
                                    const id = red.id;
                                    acc[id] = red;
                                    return acc;
                                }, {});
                                resolve();
                            }).catch(() => ({}));
                        });
                    }

                    function loadTypes() {
                        SupportTypeService.api.getAll(
                            {
                                filters: [`'status' EQ '${EntityStatus.ENABLED}'`],
                                sorts: ['name:ASC'],
                            },
                        )
                        .$promise
                        .then(data => {
                            // $scope.types = data._embedded;
                            $scope.types = data;
                        }).catch(() => ({}));
                    }

                    function loadAreas() {
                        return new Promise(resolve => {
                            AreaService.api.get(
                                {
                                    filters: [`'status' EQ '${EntityStatus.ENABLED}'`],
                                    sorts: ['name:ASC'],
                                },
                            )
                            .$promise
                            .then(data => {
                                $scope.areases = data._embedded;
                                $scope.areasesObject = data._embedded.reduce((acc, red) => {
                                    const id = red.id;
                                    acc[id] = red;
                                    return acc;
                                }, {});
                                resolve();
                            }).catch(() => ({}));
                        })
                    }

                    function loadOperators() {
                        OperatorService.api.numeric(null)
                        .$promise
                        .then(data => {
                            $scope.operators = data._embedded.filter(item => ['LE', 'GE', 'BETWEEN'].includes(item));
                        });
                    }

                    function loadIndustries() {
                        return new Promise(resolve => {
                            IndustryService.api.getAll({
                                    filters: [`'status' EQ '${EntityStatus.ENABLED}'`],
                                    sorts: ['name:ASC'],
                                })
                            .$promise
                            .then(data => {
                                $scope.industries = data._embedded;
                                $scope.industriesObject = data._embedded.reduce((acc, red) => {
                                    const id = red.id;
                                    acc[id] = red;
                                    return acc;
                                }, {});
                                resolve();
                            }).catch(() => ({}));
                        });
                    }

                /**
                 * Получение поиска
                 * @returns {Array}
                 */
                function getSearchs() {
                    let searchs = [];
                    if ($scope.pagination.search != null && !($scope.pagination.search.length < 1)) {
                        searchs.push("'name':'" + $scope.pagination.search + "'");
                    }
                    return searchs;
                }

                     /**
                 * Обновить данные таблицы
                 */
                function refresh(resetPagination = true) {
                    if (resetPagination) {
                        $scope.items = [];
                        $scope.pagination.size = $scope.paginationSize;
                    }
                    $scope.loading = true;
                    let projectId = $rootScope.activeProject && $rootScope.activeProject.id;
                    console.log(projectId, $rootScope.activeProject)
                    SupportService.api.get({
                        filters: SupportFilterService.collectFilterDto({ ...SupportFilterService.getFilters(), activeProjectId: projectId }),
                        searchs: getSearchs(),
                        sorts: ['name:ASC'],
                        page: $scope.pagination.page,
                        size: $scope.pagination.size
                    }, function (data) {
                        $scope.items = SupportService.convertDTO(data._embedded, $scope);
                        if ($scope.pagination.isPaging && data.page) {
                            $scope.pagination.totalPages = data.page.totalPages;
                            $scope.pagination.totalItems = data.page.totalElements;
                        }
                        $scope.loading = false;
                    });
                }

                function oneMorePage() {
                    if ($scope.pagination.size < $scope.pagination.totalItems) {
                        $scope.pagination.size += $scope.paginationSize;
                        refresh(false);
                    }
                }

                $scope.$watch('pagination.search', (newValue, oldValue) => {
                    if (oldValue !== newValue) {
                        $scope.refresh();
                    }
                })

                }];
